import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { BASE_URL } from "../../utils/BaseURL";
import SingleOrderItem from "./SingleOrderItem";
import { Box, Grid, Stack, Typography } from "@mui/material";
import emptycart from "../../assets/emptycart.gif";
import cartloading from "../../assets/cartloading.gif";
import { Context } from "../../utils/context";

const OrderData = () => {
  const [orders, setOrders] = useState([]);

  const { orderLoading, userOrders } = useContext(Context);

  console.log(orders);
  useEffect(() => {
    let data = userOrders?.reduce((acc, order) => {
      const productsWithOrdersData = order.products.map((product) => ({
        ...product,
        ordersData: {
          _id: order?._id,
          userID: order?.userID,
          total: order?.total,
          subtotal: order?.subtotal,
          delivery_charges: order?.delivery_charges,
          coupen_discount: order?.coupen_discount,
          coupen_applied: order?.coupen_applied,
          delivery_status: order?.delivery_status,
          payment_mode: order?.payment_mode,
          payment_status: order?.payment_status,
          shipping_address: order?.shipping_address,
          createdAt: order?.createdAt,
          updatedAt: order?.updatedAt,
        }, // Assuming OrdersData is available in the order object
      }));

      return [...acc, ...productsWithOrdersData];
    }, []);

    setOrders(data);
  }, [userOrders]);

  return (
    <Box>
      <Grid container spacing={2} justifyContent={"Center"} alignItems="center">
        <Grid item xs={11} sm={10} md={9}>
          <Typography variant="h4">Orders</Typography>
          {orderLoading ? (
            <Box my={"100px"}>
              <center>
                <img width={"320px"} src={cartloading} />
                <p style={{ fontSize: "20px" }}> Orders Loading</p>
              </center>
            </Box>
          ) : orders?.length <= 0 ? (
            <Box my={"100px"}>
              <center>
                <img width={"320px"} src={emptycart} />
                <p style={{ fontSize: "20px" }}>No Orders Found Orders</p>
              </center>
            </Box>
          ) : (
            orders?.map((el) => {
              return <SingleOrderItem key={el._id + "orderss"} data={el} />;
            })
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderData;
